import { memo } from 'react'
import { observer } from 'mobx-react'
import { PossibleVariants } from 'utils/tracking/optimizely/types'
import RCEVariantBEditPageCollapsibleBanner from 'components/AbTestComponents/CAT4558RceVoucherBanner/RCEVariantBEditPageCollapsibleBanner'
import RCEVariantCEditPageNotice from 'components/AbTestComponents/CAT4558RceVoucherBanner/RCEVariantCEditPageNotice'
import RCEVariantsBCActivatedBanner from 'components/AbTestComponents/CAT4558RceVoucherBanner/RCEVariantsBCActivatedBanner'
import TopNotActivatedVoucherBanner from './components/TopNotActivatedVoucherBanner'
import TopActivatedVoucherBanner from './components/TopActivatedVoucherBanner'
import useVoucherBannerController from './hooks/useVoucherBannerController'

const VoucherBanner = () => {
  const { model, activateRCEVoucher, trackTerms } = useVoucherBannerController()

  switch (model.kind) {
    case 'standard-contact-prompt':
      return (
        <TopNotActivatedVoucherBanner
          tenant={model.variant}
          amount={model.amount}
        />
      )
    case 'standard-activated':
      return (
        <TopActivatedVoucherBanner
          tenant={model.variant}
          amount={model.amount}
        />
      )
    case 'rce-variant-b-edit':
      return (
        <RCEVariantBEditPageCollapsibleBanner
          amount={model.amount}
          isActivated={model.isActivated}
          onActivate={activateRCEVoucher}
          onTermsClick={trackTerms}
        />
      )
    case 'rce-variant-c-edit-notice':
      return <RCEVariantCEditPageNotice amount={model.amount} />
    case 'rce-activated-additional':
      return (
        <RCEVariantsBCActivatedBanner
          amount={model.amount}
          onTermsClick={trackTerms}
          showIllustration={model.variant === PossibleVariants.VARIATION_C}
        />
      )
    default:
      return null
  }
}

export default memo(observer(VoucherBanner))
